import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ViewAppFeedbackAnswerComponent from '../components/viewAppFeedbackAnswerComponent';
import { getApplicationFeedbackAnswerListFunc } from '../actions/viewFeedbackAnswerAction';

class ViewAppFeedbackAnswerContainer extends Component {
    
    componentDidMount() {
            this.props.actions.getApplicationFeedbackAnswerListFunc(
            this.props.dispatch)
    }
    
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row"> 
                            <ViewAppFeedbackAnswerComponent
                                feedbackAnswerList={this.props.feedbackAnswerList}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getApplicationFeedbackAnswerListFunc
        }, dispatch)
    };
};

function mapStateToProps({ viewFeedbackAnswerReducer}) {
    console.log(viewFeedbackAnswerReducer);
    return {
        feedbackAnswerList: {
            isLoading: viewFeedbackAnswerReducer.isLoading,
            answerList: viewFeedbackAnswerReducer.answerList,
            errorCode: viewFeedbackAnswerReducer.errorCode,
            messageLabel: viewFeedbackAnswerReducer.messageLabel,    
            statusCode: viewFeedbackAnswerReducer.statusCode
        },
        
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewAppFeedbackAnswerContainer))